<script>
import Repositories from '@/repositories';
const SuppliersRepository = Repositories.get('suppliers');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DeleteButton from '@/components/widgets/buttons/delete-button';

/**
 * Dashboard Component
 */
export default {
  props: {
    item: Object,
  },
  components: {
    Loading,
    DeleteButton,
  },
  data() {
    return {
      isLoading: false,
      modalShow: false,
      editPrice: false,
      suppliersOptions: [],
      selectedSupplier: null,
      selectedPrice: 0,
      selectedCode: '',
      selectedName: '',
      selectedLink: '',
      selectedUnitName: '',
      selectedOrderUnitQuantity: 1,
      selectedOrderMinimumQuantity: 0,
      // Price thresholds
      selectedPriceThresholds: [],
      newThresholdMinimum: 0,
      newThresholdPrice: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      SuppliersRepository.getAll()
        .then((response) => {
          this.suppliersOptions = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    deleteItemSupplier(idPublic) {
      let newItemSuppliersList = [
        ...this.item.itemSuppliers.filter(
          (x) => x.supplierIdPublic != idPublic
        ),
      ];

      let newSupplierIdPublic = this.item.supplierIdPublic;
      let foundIndex = newItemSuppliersList.findIndex(
        (x) => x.supplierIdPublic == this.item.supplierIdPublic
      );

      if (foundIndex < 0) {
        if (newItemSuppliersList.length > 0) {
          newSupplierIdPublic = newItemSuppliersList[0].supplierIdPublic;
        } else {
          newSupplierIdPublic = null;
        }
      }

      this.$emit('update-item', {
        ...this.item,
        itemSuppliers: newItemSuppliersList,
        supplierIdPublic: newSupplierIdPublic,
      });
    },
    editItemSupplier(idPublic) {
      let itemSupplier = this.item.itemSuppliers.find(
        (x) => x.supplierIdPublic == idPublic
      );

      if (itemSupplier != undefined) {
        this.selectedSupplier = itemSupplier.supplierIdPublic;
        this.selectedPrice = itemSupplier.price;
        this.selectedCode = itemSupplier.code;
        this.selectedName = itemSupplier.name;
        this.selectedLink = itemSupplier.link;
        this.selectedUnitName = itemSupplier.unitName;
        this.selectedOrderUnitQuantity = itemSupplier.orderUnitQuantity;
        this.selectedOrderMinimumQuantity = itemSupplier.orderMinimumQuantity;
        // Load existing price thresholds
        this.selectedPriceThresholds = itemSupplier.itemSupplierPriceThresholds
          ? [...itemSupplier.itemSupplierPriceThresholds]
          : [];
        this.editPrice = true;

        this.modalShow = true;
      }
    },
    addSupplier() {
      if (this.selectedSupplier == null) return;

      let newItemSupplier = {
        idPublic: null,
        itemIdPublic: this.item.idPublic,
        supplierIdPublic: this.selectedSupplier,
        price: Number(this.selectedPrice).toFixed(5),
        code: this.selectedCode,
        name: this.selectedName,
        link: this.selectedLink,
        unitName: this.selectedUnitName,
        orderUnitQuantity: this.selectedOrderUnitQuantity,
        orderMinimumQuantity: this.selectedOrderMinimumQuantity,
        itemSupplierPriceThresholds: [...this.selectedPriceThresholds],
      };

      let newSupplierIdPublic = this.item.supplierIdPublic;
      if (
        this.item.itemSuppliers.length == 0 ||
        this.item.supplierIdPublic == null
      ) {
        newSupplierIdPublic = newItemSupplier.supplierIdPublic;
      }

      this.$emit('update-item', {
        ...this.item,
        itemSuppliers: [...this.item.itemSuppliers, newItemSupplier],
        supplierIdPublic: newSupplierIdPublic,
      });

      this.closeModal();
    },
    editSupplierPrice() {
      let itemSupplier = this.item.itemSuppliers.find(
        (x) => x.supplierIdPublic == this.selectedSupplier
      );

      if (itemSupplier == undefined) {
        this.addSupplier();
      } else {
        let editedItemSupplier = {
          ...itemSupplier,
          price: Number(this.selectedPrice).toFixed(5),
          code: this.selectedCode,
          name: this.selectedName,
          link: this.selectedLink,
          unitName: this.selectedUnitName,
          orderUnitQuantity: this.selectedOrderUnitQuantity,
          orderMinimumQuantity: this.selectedOrderMinimumQuantity,
          itemSupplierPriceThresholds: [...this.selectedPriceThresholds],
        };

        let foundIndex = this.item.itemSuppliers.findIndex(
          (x) => x.supplierIdPublic == itemSupplier.supplierIdPublic
        );
        if (foundIndex >= 0) {
          let newItemSuppliersList = [
            ...this.item.itemSuppliers.slice(0, foundIndex),
            editedItemSupplier,
            ...this.item.itemSuppliers.slice(foundIndex + 1),
          ];

          this.$emit('update-item', {
            ...this.item,
            itemSuppliers: newItemSuppliersList,
          });

          this.closeModal();
        }
      }
    },
    addPriceThreshold() {
      if (this.newThresholdMinimum <= 0 || this.newThresholdPrice < 0) {
        this.$toast.errorToast(this.$t('errors.invalidThresholdData'));
        return;
      }

      // Check if threshold with same minimum already exists
      const existingThreshold = this.selectedPriceThresholds.find(
        (t) => t.minimum === this.newThresholdMinimum
      );

      if (existingThreshold) {
        this.$toast.errorToast(this.$t('errors.thresholdAlreadyExists'));
        return;
      }

      this.selectedPriceThresholds.push({
        idPublic: null,
        minimum: this.newThresholdMinimum,
        price: Number(this.newThresholdPrice).toFixed(5),
      });

      // Sort thresholds by minimum quantity
      this.selectedPriceThresholds.sort((a, b) => a.minimum - b.minimum);

      // Reset input fields
      this.newThresholdMinimum = 0;
      this.newThresholdPrice = 0;
    },
    removePriceThreshold(index) {
      this.selectedPriceThresholds.splice(index, 1);
    },
    resetModal() {
      this.editPrice = false;
      this.selectedSupplier = null;
      this.selectedPrice = 0;
      this.selectedCode = '';
      this.selectedName = '';
      this.selectedLink = '';
      this.selectedUnitName = '';
      this.selectedOrderUnitQuantity = 1;
      this.selectedOrderMinimumQuantity = 0;
      this.selectedPriceThresholds = [];
      this.newThresholdMinimum = 0;
      this.newThresholdPrice = 0;
    },
    closeModal() {
      this.modalShow = false;
      this.resetModal();
    },
    openAddModal() {
      this.resetModal();
      this.modalShow = true;
    },
    changeDefaultSupplier(idPublic) {
      this.$emit('update-item', { ...this.item, supplierIdPublic: idPublic });
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
    itemSuppliersObjects() {
      let suppliersList = [];
      if (this.item != null && this.item.itemSuppliers != undefined) {
        this.item.itemSuppliers.forEach((itemSupp) => {
          let currentSupplier = this.suppliersOptions.find(
            (x) => x.idPublic == itemSupp.supplierIdPublic
          );
          if (
            currentSupplier != null &&
            !suppliersList.some((x) => x.idPublic == currentSupplier.idPublic)
          ) {
            suppliersList.push({
              ...currentSupplier,
              price: itemSupp.price,
              itemCode: itemSupp.code,
              itemName: itemSupp.name,
              link: itemSupp.link,
              unitName: itemSupp.unitName,
              orderUnitQuantity: itemSupp.orderUnitQuantity,
              orderMinimumQuantity: itemSupp.orderMinimumQuantity,
              itemSupplierIdPublic: itemSupp.idPublic,
              itemSupplierPriceThresholds:
                itemSupp.itemSupplierPriceThresholds || [],
            });
          }
        });
      }

      return suppliersList;
    },
    suppliersOptionsItems() {
      let suppliersList = [];
      this.suppliersOptions.forEach((x) => {
        if (!this.itemSuppliersObjects.some((y) => y.idPublic == x.idPublic)) {
          suppliersList.push(x);
        }
      });

      return suppliersList;
    },
    modalTitle() {
      return this.editPrice ? this.$t('general.edit') : this.$t('general.add');
    },
  },
};
</script>

<template>
  <div v-if="currencyFormatter != null">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <b-row>
      <b-col class="mb-1 text-right">
        <b-button
          variant="success"
          @click="openAddModal()"
          :disabled="suppliersOptionsItems.length == 0"
        >
          {{ $t('suppliers.addSupplier') }}
          <i class="fas fa-plus pl-2 pr-2" style="cursor: pointer"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="supplier-box">
          <b-row class="supplier-row" style="background-color: #f1f3f5">
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('general.default') }}
            </b-col>
            <b-col cols="1" class="flex-vertical-align">
              {{ $t('suppliers.supplierName') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('general.code') }}
            </b-col>
            <b-col cols="2" class="text-center flex-vertical-align">
              {{ $t('general.name') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('general.link') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('items.price') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('items.unitName') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('items.orderUnitQuantity') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('items.orderMinimumQuantity') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('general.edit') }}
            </b-col>
            <b-col cols="1" class="text-center flex-vertical-align">
              {{ $t('general.delete') }}
            </b-col>
          </b-row>
          <div class="scolling-row">
            <b-row
              v-for="itemSupplier in itemSuppliersObjects"
              :key="itemSupplier.idPublic"
              class="supplier-row"
            >
              <b-col cols="1 text-center flex-vertical-align">
                <i
                  v-if="itemSupplier.idPublic == item.supplierIdPublic"
                  class="fas fa-check text-success"
                  style="font-size: 1.2em"
                >
                </i>
                <i
                  v-else
                  class="fas fa-check text-secondary pl-2 pr-2"
                  @click="changeDefaultSupplier(itemSupplier.idPublic)"
                  style="cursor: pointer; font-size: 1.2em"
                >
                </i>
              </b-col>
              <b-col cols="1" class="flex-vertical-align">
                {{ itemSupplier.name }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ itemSupplier.itemCode }}
              </b-col>
              <b-col cols="2" class="text-center flex-vertical-align">
                {{ itemSupplier.itemName }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ itemSupplier.link }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ currencyFormatter.format(itemSupplier.price) }}
                <span
                  v-if="
                    itemSupplier.itemSupplierPriceThresholds &&
                      itemSupplier.itemSupplierPriceThresholds.length > 0
                  "
                  class="text-muted small"
                >
                  ({{ itemSupplier.itemSupplierPriceThresholds.length }}
                  {{ $t('items.thresholds') }})
                </span>
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ itemSupplier.unitName }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ itemSupplier.orderUnitQuantity }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                {{ itemSupplier.orderMinimumQuantity }}
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                <i
                  class="fas fa-pencil-alt text-success pl-2 pr-2"
                  @click="editItemSupplier(itemSupplier.idPublic)"
                  style="cursor: pointer; font-size: 1.2em"
                >
                </i>
              </b-col>
              <b-col cols="1" class="text-center flex-vertical-align">
                <DeleteButton
                  @clicked="deleteItemSupplier(itemSupplier.idPublic)"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- XL Modal for Add/Edit Supplier -->
    <b-modal
      v-model="modalShow"
      :title="modalTitle"
      size="xl"
      @shown="$refs.itemsuppliercodefield.focus()"
      @hidden="resetModal"
    >
      <b-container fluid>
        <b-row>
          <b-col cols="12" md="6" v-if="editPrice == false">
            <b-form-group
              id="input-group-supplier"
              :label="$t('suppliers.supplier')"
              label-for="input-supplier"
            >
              <b-form-select
                v-model="selectedSupplier"
                :options="suppliersOptionsItems"
                @change="$refs.itemsuppliercodefield.focus()"
                value-field="idPublic"
                text-field="name"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-code"
              :label="$t('general.code')"
              label-for="input-code"
            >
              <b-form-input
                v-model="selectedCode"
                ref="itemsuppliercodefield"
                :placeholder="$t('general.code')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-name"
              :label="$t('general.name')"
              label-for="input-name"
            >
              <b-form-input
                v-model="selectedName"
                ref="itemsuppliernamefield"
                :placeholder="$t('general.name')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-link"
              :label="$t('general.link')"
              label-for="input-link"
            >
              <b-form-input
                v-model="selectedLink"
                ref="itemsupplierlinkfield"
                :placeholder="$t('general.link')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-price"
              :label="$t('items.price')"
              label-for="input-price"
              :description="$t('items.basePriceDescription')"
            >
              <b-form-input
                v-model="selectedPrice"
                type="number"
                ref="itemsupplierpricefield"
                step="0.01"
                :placeholder="$t('items.price')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-unit-name"
              :label="$t('items.unitName')"
              label-for="input-unit-name"
            >
              <b-form-input
                v-model="selectedUnitName"
                ref="itemsupplierunitnamefield"
                :placeholder="$t('items.unitName')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-order-unit-quanttiy"
              :label="$t('items.orderUnitQuantity')"
              label-for="input-order-unit-quanttiy"
            >
              <b-form-input
                v-model="selectedOrderUnitQuantity"
                type="number"
                :step="item.quantityType == 'unitary' ? '1' : '.00001'"
                ref="itemsupplierunitfield"
                :placeholder="$t('items.orderUnitQuantity')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              id="input-group-order-minimum-quantity"
              :label="$t('items.orderMinimumQuantity')"
              label-for="input-order-minimum-quantity"
            >
              <b-form-input
                v-model="selectedOrderMinimumQuantity"
                type="number"
                :step="item.quantityType == 'unitary' ? '1' : '.00001'"
                ref="itemsupplierminfield"
                :placeholder="$t('items.orderMinimumQuantity')"
                @keydown.enter.prevent="editSupplierPrice"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Price Thresholds Section -->
        <b-row class="mt-4">
          <b-col cols="12">
            <h5>{{ $t('items.priceThresholds') }}</h5>
            <hr />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-card class="mb-3">
              <b-row>
                <b-col cols="12" md="5">
                  <b-form-group
                    :label="$t('items.minimumQuantity')"
                    label-for="threshold-minimum"
                  >
                    <b-form-input
                      v-model.number="newThresholdMinimum"
                      type="number"
                      :step="item.quantityType == 'unitary' ? '1' : '.00001'"
                      :placeholder="$t('items.minimumQuantity')"
                      @keydown.enter.prevent="addPriceThreshold"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="5">
                  <b-form-group
                    :label="$t('items.thresholdPrice')"
                    label-for="threshold-price"
                  >
                    <b-form-input
                      v-model.number="newThresholdPrice"
                      type="number"
                      step="0.01"
                      :placeholder="$t('items.thresholdPrice')"
                      @keydown.enter.prevent="addPriceThreshold"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="2" class="d-flex align-items-end">
                  <b-button
                    variant="success"
                    @click="addPriceThreshold"
                    class="mb-3"
                    block
                  >
                    <i class="fas fa-plus"></i>
                    {{ $t('general.add') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="selectedPriceThresholds.length > 0">
          <b-col cols="12">
            <b-table
              :items="selectedPriceThresholds"
              :fields="[
                {
                  key: 'minimum',
                  label: $t('items.minimumQuantity'),
                  class: 'text-center',
                },
                {
                  key: 'price',
                  label: $t('items.thresholdPrice'),
                  class: 'text-center',
                },
                {
                  key: 'actions',
                  label: $t('general.delete'),
                  class: 'text-center',
                },
              ]"
              striped
              bordered
              small
            >
              <template #cell(price)="data">
                {{ currencyFormatter.format(data.item.price) }}
              </template>
              <template #cell(actions)="data">
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removePriceThreshold(data.index)"
                >
                  <i class="fas fa-trash"></i>
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col cols="12">
            <b-alert show variant="info">
              {{ $t('items.noPriceThresholds') }}
            </b-alert>
          </b-col>
        </b-row>
      </b-container>

      <template #modal-footer>
        <b-button variant="secondary" @click="closeModal">
          {{ $t('general.cancel') }}
        </b-button>
        <b-button variant="success" @click="editSupplierPrice" v-if="editPrice">
          <i class="fas fa-pencil-alt mr-2"></i>
          {{ $t('general.update') }}
        </b-button>
        <b-button variant="success" @click="addSupplier" v-else>
          <i class="fas fa-plus mr-2"></i>
          {{ $t('general.add') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.supplier-box {
  border: 1px solid #ced4da;
  border-radius: 5px;
  min-height: 200px;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.supplier-row {
  padding-right: 8px;
  padding-left: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.scolling-row {
  min-height: 160px;
  max-height: 160px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
